export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds(),
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      // fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str));
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

// 产品数据格式化
export function formatGoods(data) {
  data.forEach((res) => {
    if (res.spec != undefined && res.spec.length != 0 && res.spec != null && res.spec != "") {
      res.goods_price = res.spec[0]["goods_price"];
      res.goods_market_price = res.spec[0]["goods_market_price"];
      res.goods_num = res.spec[0]["goods_num"];
      res.all_goods_num = 0;
      res.spec.forEach((specRes) => {
        res.all_goods_num += parseInt(specRes.goods_num);
      });
    }
  });

  return data;
}

export function getQueryData() {
  const queryObj = {};
  const href = window.location.href || "";
  const search = window.location.search || "";
  const hash = window.location.hash || "";

  const appendParams = (queryString) => {
    if (!queryString) return;
    const searchParams = new URLSearchParams(queryString);
    searchParams.forEach((value, key) => {
      queryObj[key] = value;
    });
  };

  appendParams(search);

  if (!Object.keys(queryObj).length && hash.indexOf("?") !== -1) {
    appendParams(hash.slice(hash.indexOf("?")));
  }

  if (!Object.keys(queryObj).length && href.indexOf("?") !== -1) {
    appendParams(href.slice(href.indexOf("?")));
  }

  return queryObj;
}

/**
 * { 1: 'A', 2: 'B' } 转化为
 * [{
 *  keyLabel: 1,
 *  value: 'A'
 * },
 * {
 *  keyLabel: 2,
 *  value: 'B'
 * }]
 * @param {object} data
 * @param {*} keyLabel
 * @param {*} valueLabel
 */
export function formatKeyValue(data, keyLabel, valueLabel) {
  let newData = [];
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      let item = {};
      item[keyLabel] = key;
      item[valueLabel] = data[key];
      newData.push(item);
    }
  }
  return newData;
}
